// import useSite from 'hooks/use-site';
import styles from "./AcceptPdpa.module.scss";
import { setCookies, hasCookie } from "cookies-next";
import { useState } from "react";
import useSite from "hooks/use-site";
import Link from "next/link";
import moment from "moment";

const text = {
  th: {
    textBtn: "ยอมรับ",
    textPolicy1:
      "เว็บไซต์ของเราใช้คุกกี้เพื่อเพิ่มประสิทธิภาพและประสบการณ์ที่ดีในการใช้เว็บไซต์ท่านสามารถศึกษารายละเอียดการใช้คุกกี้ได้ที่",
    textPolicy2: "นโยบายการใช้คุกกี้",
    textPolicy3: "และ",
    textPolicy4: "คำประกาศเกี่ยวกับความเป็นส่วนตัว",
    textPolicy5: "ของเรา",
  },
  en: {
    textBtn: "Accept",
    textPolicy1: `Our website uses cookies to enhance our website's performance and experience. You can find out more about our use of cookies in our`,
    textPolicy2: "Cookie Policy",
    textPolicy3: "and",
    textPolicy4: "Privacy Notice",
  },
};

const AcceptPdpa = () => {
  const { locale } = useSite();
  const lang = locale.toLowerCase();
  const [isAccept, setIsAccept] = useState(hasCookie(process.env.COOKIE_PDPA));
  const acceptCookiePDPA = () => {
    if (!hasCookie(process.env.COOKIE_PDPA)) {
      let maxAge = moment()
        .add(1, "years")
        .diff(moment().startOf("day"), "seconds"); // 1 year
      setCookies(process.env.COOKIE_PDPA, true, { maxAge });
      setIsAccept(true);
    }
  };
  return (
    <>
      {!isAccept && (
        <div className={styles.layoutPdpa}>
          <p>
            {text[lang].textPolicy1}
            <span>
              {" "}
              "
              <Link href={`/cookies-policy`}>
                <a>{text[lang].textPolicy2}</a>
              </Link>
              " {text[lang].textPolicy3}{" "}
            </span>
            <span>
              "
              <Link href={`/privacy-policy`}>
                <a>{text[lang].textPolicy4}</a>
              </Link>
              "{lang === "th" ? ` ${text[lang].textPolicy5}` : "."}
            </span>
          </p>
          <div className={styles.btnAccept}>
            <button onClick={acceptCookiePDPA}>{text[lang].textBtn}</button>
          </div>
        </div>
      )}
    </>
  );
};

export default AcceptPdpa;
